/* ==========================================================================
   TNF promotion display layer 1.2.0                              2026-09-27
   1.2.0 (27 Sep 2026): more than one promotion can run at once - Halloween 30 %
   and 25 % on everything else - so each price asks promotionFor(element) which
   promotion applies to IT. List order is priority; nothing else changes.
   1.1.0 (Brief 6): a promotion that ENDS (or starts, or stops applying) while
   the page is open is acted on at that moment - a timer is set for the next
   start / end time of every definition, the page is re-checked when the tab
   comes back and every 30 s, and each change fires "tnf:promo-change" so the
   catalogue product page re-renders every price from its quote. Card badges
   drop the struck price, the saving and the sale styling in the same pass.
   Preview-only fixture expiry for testing: ?tnf_sale_demo=20&tnf_sale_demo_for=30
   (ends 30 s after it is first seen in this tab).
   Prepares the price badges for a FUTURE automatic discount. Nothing here
   creates a discount: Shopify's automatic discount (once one exists) prices
   the cart and checkout; this layer only makes the badges say the same thing
   beforehand, from ONE promotion definition, and never from a guess.

   Where the definition comes from (see snippets/tnf-promo-config.liquid):
     window.TNF_PROMO = [ { id, title, kind: 'percentage' | 'amount', value,
                            starts_at, ends_at (ISO 8601), markets: ['AU','US'] | [],
                            currencies: ['AUD','USD'] | [],
                            include:  { handles: [], tags: [], collections: [] },   -- empty = every product
                            exclude:  { handles: [], tags: [], collections: [], accessories: true },
                            min_amount (optional, in the market currency),
                            combines_with_compare_at: false } ]
   CONNECTION PENDING: until the store's automatic discount is read into that
   definition (release step, see 22-*-HANDOVER.md), TNF_PROMO is [] and every
   badge shows its regular state. The preview fixture below exists only so the
   sale state can be reviewed on the UNPUBLISHED preview: it never runs on the
   live theme (Shopify.theme.role === 'main' disables it), it has no default
   rate (?tnf_sale_demo=<percent> supplies one for this browser tab only), and
   it never writes a compare-at price anywhere.

   Rules (Jack, 24 Sep 2026): the genuine regular price (data-tnf-regular) is
   the only reference; a badge already showing a merchant compare-at sale is
   left alone (no double discount); accessories follow the definition's own
   exclusion; when nothing applies, all sale styling is removed again.
   ========================================================================== */
(function () {
  'use strict';
  var THEME_ROLE = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
  var IS_LIVE = THEME_ROLE === 'main';
  var CUR = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || (document.documentElement.getAttribute('data-currency') || '');
  /* 1.3.0 (2 Oct 2026, UK launch): three storefronts; GBP prints with £ */
  var MARKET = /\.au$/i.test(location.hostname) ? 'AU' : /\.co\.uk$/i.test(location.hostname) ? 'UK' : 'US';
  var PREFIX = { AUD: 'A$', USD: 'US$', GBP: '\u00a3', UK: '\u00a3' };

  /* ---- preview-only fixture ------------------------------------------------ */
  var FX = null;   /* the fixture as first read in this page: { pct, ends } */
  function fixture() {
    if (IS_LIVE) return null;
    if (!FX) {
      var m = /[?&]tnf_sale_demo=([^&#]*)/.exec(location.search), f = /[?&]tnf_sale_demo_for=(\d+)/.exec(location.search);
      var raw = null, ends = null;
      try {
        if (m) {
          raw = decodeURIComponent(m[1]);
          if (raw === '' || raw === 'off' || raw === '0') { sessionStorage.removeItem('tnf_sale_demo'); FX = { pct: 0 }; return null; }
          ends = f ? Date.now() + parseInt(f[1], 10) * 1000 : Date.now() + 7 * 864e5;
          sessionStorage.setItem('tnf_sale_demo', JSON.stringify({ pct: raw, ends: ends }));
        } else {
          var st = sessionStorage.getItem('tnf_sale_demo');
          if (st) { try { var o = JSON.parse(st); raw = String(o.pct); ends = o.ends; } catch (e) { raw = st; ends = Date.now() + 7 * 864e5; } }
        }
      } catch (e) { raw = m ? decodeURIComponent(m[1]) : null; ends = f ? Date.now() + parseInt(f[1], 10) * 1000 : Date.now() + 7 * 864e5; }
      FX = { pct: parseFloat(raw), ends: ends };
    }
    var pct = FX.pct;
    if (!(pct > 0 && pct < 100)) return null;
    return { id: 'preview-fixture', title: 'PREVIEW FIXTURE ' + pct + '% (not a real promotion)', kind: 'percentage', value: pct,
      starts_at: new Date(Date.now() - 864e5).toISOString(), ends_at: new Date(FX.ends).toISOString(),
      markets: [], currencies: [], include: { handles: [], tags: [], collections: [] },
      exclude: { handles: [], tags: [], collections: [], accessories: true }, combines_with_compare_at: false, fixture: true };
  }

  /* ---- eligibility ------------------------------------------------------- */
  function activeNow(p, now) {
    var s = p.starts_at ? Date.parse(p.starts_at) : -Infinity, e = p.ends_at ? Date.parse(p.ends_at) : Infinity;
    if (isNaN(s) || isNaN(e)) return false;
    return now >= s && now <= e;
  }
  function inMarket(p) {
    if (p.markets && p.markets.length && p.markets.indexOf(MARKET) < 0) return false;
    if (p.currencies && p.currencies.length && CUR && p.currencies.indexOf(CUR) < 0) return false;
    return true;
  }
  function listed(set, el) {
    if (!set) return false;
    var h = el.getAttribute('data-tnf-handle') || '';
    var tags = (el.getAttribute('data-tnf-tags') || '').split(',').filter(Boolean);
    var cols = (el.getAttribute('data-tnf-collections') || '').split(',').filter(Boolean);
    if (set.handles && set.handles.length && set.handles.indexOf(h) >= 0) return true;
    if (set.tags && set.tags.length && tags.some(function (t) { return set.tags.indexOf(t) >= 0; })) return true;
    if (set.collections && set.collections.length && cols.some(function (c) { return set.collections.indexOf(c) >= 0; })) return true;
    return false;
  }
  function eligible(p, el) {
    if (el.getAttribute('data-tnf-sale') === 'compare-at' && !p.combines_with_compare_at) return false;   /* merchant sale already shown: never double */
    if (p.exclude) {
      if (p.exclude.accessories && el.getAttribute('data-tnf-accessory') === 'true') return false;
      if (listed(p.exclude, el)) return false;
    }
    var inc = p.include || {};
    var anyInclude = (inc.handles && inc.handles.length) || (inc.tags && inc.tags.length) || (inc.collections && inc.collections.length);
    if (anyInclude && !listed(inc, el)) return false;
    return true;
  }
  function discounted(p, regular) {
    var v = Number(p.value);
    if (!(regular > 0) || !(v > 0)) return null;
    if (p.min_amount && regular < Number(p.min_amount)) return null;
    var out = p.kind === 'amount' ? regular - v : regular * (1 - v / 100);
    if (!(out > 0) || out >= regular) return null;
    /* To the nearest cent, off the price the card itself prints. The engine
       takes the promotion off that same printed regular price and rounds the
       same way, so a card and a product page reach one figure: A$657 less 25%
       is A$492.75 in both places. */
    return Math.round(out * 100) / 100;
  }
  function fmt(el, n) {
    var cur = el.getAttribute('data-tnf-market') || CUR || '';
    var pre = PREFIX[cur] || (cur === 'AU' ? 'A$' : cur === 'US' ? 'US$' : cur === 'UK' ? '\u00a3' : '$');
    var s = (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
    var parts = s.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return pre + parts.join('.');
  }
  function saveLabel(p, regular, now) {
    if (p.kind === 'percentage') return 'Save ' + (Math.round(Number(p.value) * 10) / 10) + '%';
    return 'Save ' + fmt({ getAttribute: function () { return CUR; } }, regular - now);
  }

  /* ---- apply / clear on a badge ------------------------------------------- */
  function clear(el) {
    if (!el.hasAttribute('data-tnf-promo')) return;
    var now = el.querySelector('[data-tnf-now]'); if (now && el.getAttribute('data-tnf-promo-orig') != null) now.textContent = el.getAttribute('data-tnf-promo-orig');
    var was = el.querySelector('.tnf-badge__was[data-tnf-promo-was]'); if (was) was.parentNode.removeChild(was);
    var save = el.querySelector('.tnf-badge__save[data-tnf-promo-save]'); if (save) save.parentNode.removeChild(save);
    el.classList.remove('tnf-badge--sale', 'tnf-badge--promo');
    el.removeAttribute('data-tnf-promo'); el.removeAttribute('data-tnf-promo-orig'); el.removeAttribute('data-tnf-promo-price');
    el.setAttribute('data-tnf-price', el.getAttribute('data-tnf-regular') || el.getAttribute('data-tnf-price'));
  }
  function apply(el, p) {
    var regular = parseFloat(el.getAttribute('data-tnf-regular'));
    var sale = discounted(p, regular); if (sale == null) { clear(el); return false; }
    var now = el.querySelector('[data-tnf-now]'); if (!now) return false;
    if (el.getAttribute('data-tnf-promo') === p.id && el.getAttribute('data-tnf-promo-price') === String(sale)) return true;
    clear(el);
    el.setAttribute('data-tnf-promo', p.id); el.setAttribute('data-tnf-promo-orig', now.textContent); el.setAttribute('data-tnf-promo-price', String(sale));
    var was = document.createElement('s'); was.className = 'tnf-badge__was'; was.setAttribute('data-tnf-promo-was', ''); was.textContent = fmt(el, regular);
    was.setAttribute('aria-label', 'Regular price ' + fmt(el, regular));
    el.insertBefore(was, now);
    now.textContent = fmt(el, sale);
    var save = document.createElement('span'); save.className = 'tnf-badge__save'; save.setAttribute('data-tnf-promo-save', ''); save.textContent = saveLabel(p, regular, sale);
    el.appendChild(save);
    el.classList.add('tnf-badge--sale', 'tnf-badge--promo');
    el.setAttribute('data-tnf-price', String(sale));
    return true;
  }

  /* ---- the central settings file, when it is there ------------------------ */
  /* assets/tnf-promotion-1-0-0.js is the one place a percentage is changed. The
     pricing engine reads it for the price; this layer reads it for the badge,
     so a card, a product page, the creator and the checkout cannot end up
     quoting different rates because somebody edited one file and not another.
     A real automatic discount mirrored into TNF_PROMO still wins - that one is
     Shopify's and the cart will apply it whatever this file says - but the
     preview entries the theme emits for an unpublished review are replaced by
     it, so switching the sale off here switches the badges off too. */
  function fromSettings() {
    var S = window.TNF_PROMOTION_SETTINGS, W = window.TNF_PROMOTION_OVERRIDE;
    if (!S || !S.sale) return null;
    var s = S.sale;
    var on = s.enabled === true;
    if (W && W.enabled === true) on = true;
    if (W && W.enabled === false) on = false;
    if (!on) return null;
    var r = s.rates || {}, hal = (s.halloweenHandles || []).slice();
    var noAcc = s.excludeAccessories !== false;
    var starts = s.startsAt || null, ends = s.endsAt || null;
    var out = [];
    if (hal.length && r.halloween > 0) {
      out.push({ id: 'tnf-settings-halloween', title: s.halloweenTitle || 'Halloween Sale',
        kind: 'percentage', value: r.halloween * 100, starts_at: starts, ends_at: ends,
        markets: [], currencies: [],
        include: { handles: hal, tags: [], collections: [] },
        exclude: { handles: [], tags: [], collections: [], accessories: noAcc },
        min_amount: 0, combines_with_compare_at: false, settings: true });
    }
    if (r.standard > 0) {
      out.push({ id: 'tnf-settings-standard', title: s.title || 'Sale',
        kind: 'percentage', value: r.standard * 100, starts_at: starts, ends_at: ends,
        markets: [], currencies: [],
        include: { handles: [], tags: [], collections: [] },
        exclude: { handles: hal, tags: [], collections: [], accessories: noAcc },
        min_amount: 0, combines_with_compare_at: false, settings: true });
    }
    return out.length ? out : null;
  }
  /* every promotion this page could apply, in priority order */
  function baseList() {
    var list = (window.TNF_PROMO && window.TNF_PROMO.length) ? window.TNF_PROMO.slice() : [];
    if (!window.TNF_PROMOTION_SETTINGS) return list;
    var real = list.filter(function (p) { return p && !p.preview; });
    var cs = fromSettings();
    return cs ? real.concat(cs) : real;
  }

  /* ---- the promotion in force ----------------------------------------------- */
  /* 1.2.0 (27 Sep 2026): a store can run more than one promotion at once - Halloween 30 %
     and 25 % on everything else - so "the promotion" is no longer a single answer.
     promotionFor(el) answers the question that actually matters for a price: which promotion
     applies to THIS product. The first one it is eligible for wins, so list order is priority. */
  function promotionFor(el) {
    var now = Date.now();
    var list = baseList();
    var fx = fixture(); if (fx) list.push(fx);
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (p && activeNow(p, now) && inMarket(p) && eligible(p, el)) return p;
    }
    return null;
  }
  /* The made-to-size catalogue page (assets/tnf-cat-1-1-0.js) asks this module two questions in a
     fixed order: promotion() - what is running - and then eligible(p, <this sign>). That pairing was
     written when only one promotion could run, and on its own it cannot choose between two. It does
     not have to: a product page is about ONE product, and the page states which one in
     window.TNF_CAT_CONFIG (handle, tags, collections) - the same product the engine asks about a
     moment later. So on a catalogue product page promotion() answers for THAT product, and the two
     questions agree. Everywhere else it answers as before: the first promotion running in this
     market, which is what the page-level flag and window.__tnfPromo report. */
  function pageContext() {
    var c = window.TNF_CAT_CONFIG;
    if (!c || !c.handle) return null;
    var el = document.createElement('div');
    el.setAttribute('data-tnf-handle', c.handle || '');
    el.setAttribute('data-tnf-tags', (c.tags || []).join(','));
    el.setAttribute('data-tnf-collections', (c.collections || []).join(','));
    el.setAttribute('data-tnf-accessory', 'false');
    return el;
  }
  function promotion() {
    var pel = pageContext();
    if (pel) return promotionFor(pel);
    var now = Date.now();
    var list = baseList();
    var fx = fixture(); if (fx) list = list.concat([fx]);
    for (var i = 0; i < list.length; i++) { var p = list[i]; if (p && activeNow(p, now) && inMarket(p)) return p; }
    return null;
  }
  var ticking = false, lastKey = null, timer = 0;
  function keyOf(p) { return p ? p.id + '|' + p.kind + '|' + p.value + '|' + (p.ends_at || '') : ''; }
  function run(root) {
    var p = promotion();
    var els = (root || document).querySelectorAll('.tnf-badge[data-tnf-regular]');
    var n = 0;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var pel = promotionFor(el);            /* 1.2.0: this product's own promotion */
      if (pel) { if (apply(el, pel)) n++; } else clear(el);
    }
    document.documentElement.classList.toggle('tnf-promo-on', !!p);
    window.__tnfPromo = { promotion: p, applied: n, badges: els.length, live: IS_LIVE, market: MARKET, currency: CUR, source: p && p.fixture ? 'preview-fixture' : (p && p.settings ? 'tnf-promotion-1-0-0.js' : (p ? 'TNF_PROMO' : 'none (connection pending)')), key: keyOf(p) };
    var k = keyOf(p);
    if (!root && lastKey !== null && k !== lastKey) {
      try { document.dispatchEvent(new CustomEvent('tnf:promo-change', { detail: { promotion: p } })); } catch (e) {}
    }
    if (!root) { lastKey = k; schedule(); }
    return window.__tnfPromo;
  }
  /* the next moment anything can change: the soonest start or end time still ahead of us */
  function schedule() {
    clearTimeout(timer);
    var now = Date.now(), next = Infinity;
    var list = baseList();
    var fx = fixture(); if (fx) list.push(fx);
    list.forEach(function (p) {
      [p && p.starts_at, p && p.ends_at].forEach(function (t) { var v = t ? Date.parse(t) : NaN; if (!isNaN(v) && v > now && v < next) next = v; });
    });
    if (next === Infinity) return;
    timer = setTimeout(function () { run(); }, Math.min(6 * 3600e3, Math.max(0, next - now) + 60));
  }
  function soon() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; run(); }); }
  function start() {
    run();
    if (window.MutationObserver) new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) if (m[i].addedNodes && m[i].addedNodes.length) { soon(); return; } }).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) run(); });
    setInterval(function () { run(); }, 30000);   /* safety net: a clock change or a sleeping tab */
  }
  window.TNF_PROMO_API = { run: run, promotion: promotion, promotionFor: promotionFor, discounted: discounted, eligible: eligible, fmt: fmt };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
